import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../../@types/RootState';

const initialState = '';

const slice = createSlice({
  name: 'ipa.strategy.rules.filters.name',
  initialState,
  reducers: {
    SET_RULES_FILTERS_NAME: (_state, action: PayloadAction<string>) => {
      return action.payload;
    },
  },
});

export const selectorRulesPageFiltersName = (state: RootState) => state.ipa.strategy.rules.filters.name;

export const { SET_RULES_FILTERS_NAME } = slice.actions;
export default slice.reducer;
